import { useStore } from '@/hooks/useStore';
import { UserActionTypes } from '@/store/modules/user';

export interface UseLogoutResult {
  logout: () => Promise<void>;
}

export function useLogout(): UseLogoutResult {
  const store = useStore();

  const logout = async(): Promise<void> => {
    try {
      const res = await store.dispatch(UserActionTypes.LOGOUT);
      location.href = res?.redirect_url || '/login';
    } catch (e) {
      console.error('logout error', e);
    }
  };

  return { logout };
}
